import React from "react";
import { ZoomImageModal } from "../../../components/ZoomImageModal/ZoomImageModal";

export function CoolerImageModal({ isOpen, onClose, imageUrl, isLoading, onDownload }) {
  return (
    <ZoomImageModal
      isOpen={isOpen}
      onClose={onClose}
      imageUrl={imageUrl}
      isLoading={isLoading}
      title="Cooler Position Image"
      onDownload={onDownload}
      size="2xl"
    />
  );
}